'use strict';

function descriptionFadeToggle() {
    const $descriptionBlock = $('.js-collection-description');
    if ($descriptionBlock.length) {
        const offset = $(window).height() / 2;
        const descriptionBlockRect = $descriptionBlock[0].getBoundingClientRect().top;

        if (descriptionBlockRect < offset) {
            if (!$descriptionBlock.hasClass('fadein')) {
                $descriptionBlock.addClass('fadein');
            }
        }
    }
}

/**
 * @description Initialize block
 */
function initBlock() {
    descriptionFadeToggle();
}

/**
 * @description Initialize event handlers for the discover block
 */
function initializeEvents() {
    $(window).scroll(function () {
        descriptionFadeToggle();
    });
}

const description = {
    init: function() {
        initBlock();
        initializeEvents();
    }
};

module.exports = description;
